module.exports = __webpack_public_path__ + "img/icon_red_cm.1ec06a30.png";